import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    LoginToken: null,
    ParentID: null,
    userIP: null,
    college: null,
    SessionID: null,
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        loginSuccess: (state, action) => {
            state.LoginToken = action.payload.LoginToken;
            state.ParentID = action.payload.ParentID;
            state.userIP = action.payload.userIP;
            state.college = action.payload.college;
            state.SessionID = action.payload.SessionID;
        },
        logout: (state) => {
            state.LoginToken = null;
            state.ParentID = null;
            state.userIP = null;
            state.college = null;
            state.SessionID = null;
        },
        // Action to clear all persisted data (will be used with persistor.purge())
        clearAllData: (state) => {
            return initialState;
        },
    },
});

export const { loginSuccess, logout, clearAllData } = loginSlice.actions;
export default loginSlice.reducer;
